import { render, staticRenderFns } from "./bannerItem.vue?vue&type=template&id=0a03fc56&scoped=true"
import script from "./bannerItem.vue?vue&type=script&lang=js"
export * from "./bannerItem.vue?vue&type=script&lang=js"
import style0 from "./bannerItem.vue?vue&type=style&index=0&id=0a03fc56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a03fc56",
  null
  
)

export default component.exports